<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>投入再生能源</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <p>和平電廠具有 20 年豐富的電廠運轉及長期穩定供電經驗。</p>
        <p>我們依循母公司台泥 發展多元綠電的政策方向，以「火」為基石，加入永續能源「光」與「水」，因為我們知道再生能源的佔比越高，每一度電產生的排碳量就會越低，和平電力不放過廠內任何一絲被忽略的能量，轉成可再利用的電能。</p>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="sectTit">電廠內盡其可能建置光電設備</div>
        <swiper
          :modules = "modules"
          :slides-per-view="1"
          :space-between="1"
          :autoplay="{delay:3000, disableOnInteraction:false}"
          :speed="1000"
          :loop="true"
          :pagination="{clickable:true}"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          class="swiper"
        >
          <swiper-slide class="cover cover1"></swiper-slide>
          <swiper-slide class="cover cover2"></swiper-slide>
          <swiper-slide class="cover cover3"></swiper-slide>
          <swiper-slide class="cover cover4"></swiper-slide>
        </swiper>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="sectTit">綠電自發自用 屋頂光電與小水力</div>
        <div class="renewable">
          <div class="item">
            <div class="icon">
              <img src="../../assets/energyTransitionRenewable/icon3_01.png" />
            </div>
            <div class="desp">
              <div class="itemTit">屋頂光電</div>
              <p>和平電力設置自發、自用的再生能源發電設備，提供廠內輔機設備用電，屋頂全面建置太陽能板，預計設置裝置容量 1809kW，預估年發電量為 201 萬度，2025 年太陽光電系統發電量已達 84.2 萬度。</p>
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <img src="../../assets/energyTransitionRenewable/icon3_02.png" />
            </div>
            <div class="desp">
              <div class="itemTit">小水力</div>
              <p>電廠運作需要大量的冷卻水進行降溫，這些水的來源是海水，使用過後的冷卻水按照政府規定的排放標準，直接透過專屬渠道排回大海，為增加利用效益，和平電力規劃複合式再生能源發電，在既有渠道上設置小水力發電機組，藉由冷卻循環水圍堰的位能差轉換為電能，併接廠內用電系統自發自用。</p>
              <p>預計 2028 年完工，裝置容量 576kW，預估年發電量 390 萬度。</p>
              <div class="explain">
                <div class="imgContainer3-1">
                  <div class="info">
                    <div>
                      <span class="txt1">併接高壓系統</span> <span class="txt2">位能差發電</span>
                    </div>
                    <div class="data">預估 <span class="num" ref="num">3900000</span> 度/年</div>
                  </div>
                </div>
                <div class="imgContainer3-2">
                  <div class="imgTit">冷卻循環水圍堰</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Util, ImgContainerAutoResize, NumRun } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default defineComponent({
  name: 'EnergyTransitionRenewable',
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide
  },
  setup() {
    const onSwiper = (swiper: any) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay]
    };
  },
  data() {
    return {
      numBoundingBottom: 0,
      numHeight: 0,
      isShowNum: false,
      waterPowerDiagrameW: 612,
      waterPowerDiagrameRatio: 1
    }
  },
  methods:{
    setWaterPowerDiagrameInfoSize: function() {
      setTimeout( ()=> {
        this.waterPowerDiagrameRatio = (document.querySelector(".imgContainer3-1") as HTMLElement).offsetWidth / this.waterPowerDiagrameW;
        (document.querySelector(".imgContainer3-1 .info") as HTMLElement).style.transform = "scale(" + this.waterPowerDiagrameRatio + ")";
      }, 100);
    },
    showNum: function() {
      new NumRun(document.querySelector(".num") as HTMLElement, 700);
    },
    chkShowNum: function() {
      let _this = this;
      this.numBoundingBottom = (this.$refs.num as HTMLElement).getBoundingClientRect().bottom;
      this.numHeight = (this.$refs.num as HTMLElement).offsetHeight;

      if( Util.getDomHeight() > (_this.numBoundingBottom + 50)) {
        if(!_this.isShowNum) {          
          _this.isShowNum = true;
          _this.showNum();
        }
      }

      // if( window.scrollY + Util.getDomHeight() > _this.coralOffsetTop ) {
      // }

      // if( window.scrollY + Util.getDomHeight() > _this.coralOffsetTop + _this.coralHeight) {
      // }
    },
  },
  mounted() {
    setTimeout( () => {
      this.chkShowNum();
    }, 50);

    window.addEventListener("scroll", () => {
      this.chkShowNum();
    });

    this.setWaterPowerDiagrameInfoSize();
    window.addEventListener("resize", () => {
      this.setWaterPowerDiagrameInfoSize();
    });

    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover2") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover3") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover4") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-1") as HTMLElement, 0.6);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-2") as HTMLElement, 1);    
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/energyTransitionRenewable/kv.webp");
  background-position: center;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 {
  background: #F4F3F3;
}

.sect1 p {
  line-height: 2em;
}

.sect2 {
  background: #63BFAA;
}

.sect2 .sectTit {
  margin: 0 0 20px;
  letter-spacing: 3px;
  text-align: center;
  font-size: 36px;
  color: #fff;
}

.sect2 .swiper {
  border-radius: 20px;
}

.sect2 .swiper .swiper-wrapper {
  /* overflow: hidden; */
}

.sect2 .swiper .cover1 {
    background: url(../../assets/energyTransitionRenewable/carousel2_01.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover2 {
    background: url(../../assets/energyTransitionRenewable/carousel2_02.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover3 {
    background: url(../../assets/energyTransitionRenewable/carousel2_03.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover4 {
    background: url(../../assets/energyTransitionRenewable/carousel2_04.webp) center;
    background-size: cover;
}

.sect2 .swiper .swiper-pagination {
  /* bottom: -40px !important; */
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border: solid 1px #fff;
  background: #404040;
  opacity: 0.8;
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fff;
}

.sect3 {
  /* background: #F4F3F3; */
}

.sect3 .sectTit {
  margin: 0 0 40px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect3 p {
  line-height: 2em;
}

.sect3 .renewable .item {
  margin: 0 0 40px;
  display: flex;
  justify-content: space-between;
}

.sect3 .renewable .item:last-child {
  margin: 0;
}

.sect3 .renewable .item .icon {
  flex: 0 0 10%;
}

.sect3 .renewable .item .icon img {
  width: 100%;
}

.sect3 .renewable .item .desp {
  flex: 0 0 85%;
  padding: 0 0 20px;
  border-bottom: solid 5px #c0c0c0;
}

.sect3 .renewable .item:last-child .desp {
  border-bottom: none;
}

.sect3 .renewable .item .desp .itemTit {
  letter-spacing: 2px;
  font-size: 24px;
}

.sect3 .renewable .item:nth-child(1) .desp .itemTit {
  color: #F3C500;
}

.sect3 .renewable .item:nth-child(2) .desp .itemTit {
  color: #64C0AB;
}

.sect3 .renewable .item .desp .explain {
  margin: 40px 0 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect3 .renewable .item .desp .explain .imgContainer3-1 {
  flex: 0 0 60%;
  position: relative;
  background: url(../../assets/energyTransitionRenewable/pic3_01.png) center bottom no-repeat;
  background-size: cover;
}

.sect3 .renewable .item .desp .explain .imgContainer3-1 .info {
  width: 380px;
  padding: 0px 10px 5px;
  box-sizing: border-box;
  right: 1%;
  bottom: 5%;
  position: absolute;
  text-align: center;
  background: #D7E9E5;
  transform-origin: right bottom;
}

.sect3 .renewable .item .desp .explain .imgContainer3-1 .info .txt1 {
  font-size: 20px;
  color: #000;
}

.sect3 .renewable .item .desp .explain .imgContainer3-1 .info .txt2 {
  font-size: 30px;
  color: #E99776;
}

.sect3 .renewable .item .desp .explain .imgContainer3-1 .info .data {
  padding: 0 30px;
  border-radius: 50px;
  color: #fff;
  background: #000;
}

.sect3 .renewable .item .desp .explain .imgContainer3-1 .info .data .num {
  display: inline-block;
  line-height: 1.5em;
  font-weight: 900;
  font-size: 40px;
  color: #F2C400;
  opacity: 0;
}

.sect3 .renewable .item .desp .explain .imgContainer3-2 {
  flex: 0 0 35%;
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  background: url(../../assets/energyTransitionRenewable/pic3_02.jpg) center bottom no-repeat;
  background-size: cover;
}

.sect3 .renewable .item .desp .explain .imgContainer3-2 .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect2 .sectTit {
    font-size: 24px;
  }

  .sect3 .renewable .item .desp .explain .imgContainer3-1 {
    flex: 0 0 100%;
  }

  .sect3 .renewable .item .desp .explain .imgContainer3-2 {
    flex: 0 0 100%;
    margin: 20px 0 0;
  }
}
</style>
